import useDebounce from 'hooks/useDebounce'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import Search from 'UIKit/Search'

const SearchInput: React.FC<{ updateSearchContent: (text: string) => void }> = ({ updateSearchContent }) => {
  const [value, setValue] = useState('')
  const gameSeachPayload = useDebounce(value, 600)

  useEffect(() => {
    updateSearchContent(gameSeachPayload)
  }, [gameSeachPayload])

  const { t } = useTranslation()

  return (
    <StyledSearchContainer
      id="search-input"
      onValueChanged={(value: string) => setValue(value)}
      value={value}
      width="100%"
      placeholder={`${t('Search Games')}`}
      mb="24px"
    />
  )
}

const StyledSearchContainer = styled(Search)`
  height: 44px;
  border: unset !important;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.04);
  backdrop-filter: blur(6px);
`

export default SearchInput
